import { createFileRoute, Outlet } from "@tanstack/react-router";
import { ErrorBoundaryComponent } from "#/components/error-boundary";
import { Page } from "#/components/page";
import { TabsNavigation } from "#/components/tabs-navigation";
import { m } from "#/paraglide/messages";

export const Route = createFileRoute("/$locale/{-$schoolyear}/_authenticated/$school/detail")({
  component: SchoolDetailLayout,
  errorComponent: SchoolDetailError,
});

function SchoolDetailLayout() {
  const { locale, schoolyear, school } = Route.useParams();

  return (
    <Page>
      <Page.TopHeader className="pb-0">
        <TabsNavigation className="">
          <TabsNavigation.List className="-mb-px">
            <TabsNavigation.Link
              to="/$locale/{-$schoolyear}/$school/detail/info"
              params={{ locale, schoolyear, school }}
            >
              {m["school.tabs.info"]()}
            </TabsNavigation.Link>
            <TabsNavigation.Link
              to="/$locale/{-$schoolyear}/$school/detail/import/$type"
              params={{ locale, schoolyear, school, type: "modify-existing-year" }}
            >
              {m["common.actions.importeren"]()}
            </TabsNavigation.Link>
            <TabsNavigation.Link
              to="/$locale/{-$schoolyear}/$school/detail/docenten"
              params={{ locale, schoolyear, school }}
            >
              {m["common.labels.docenten"]()}
            </TabsNavigation.Link>
          </TabsNavigation.List>
        </TabsNavigation>
      </Page.TopHeader>
      <Outlet />
    </Page>
  );
}

function SchoolDetailError({ error }: { error: unknown }) {
  const params = Route.useParams();
  return <ErrorBoundaryComponent error={error} params={params} />;
}
